"use strict";
import { Map } from "immutable";
export default {
  create(route, opts = {}) {
    const { query, action, stealth } = Object.assign(
      {},
      { query: null, action: "pushState", stealth: true },
      opts
    );
    return Map({
      __type__: "UrlUpdate",
      route,
      query,
      action,
      stealth
    });
  },
  isStealthRouteUpdate(object) {
    return Map.isMap(object) && object.get("__type__") === "UrlUpdate" && object.get("stealth");
  },
  isOnYourFaceRouteUpdate(object) {
    return Map.isMap(object) && object.get("__type__") === "UrlUpdate" && !object.get("stealth");
  },
  perform(history, urlUpdate) {
    const action = urlUpdate.get("action");
    const route = urlUpdate.get("route");
    history[action](null, route, urlUpdate.get("query"));
    return true;
  }
};
